import classNames from 'classnames/bind';
import styles from './PostPage.module.scss';
import PostList from '~/component/PostList';
import { useContext, useEffect, useRef } from 'react';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import useMeta from '~/hooks/useMeta';
import routes from '~/configs';

const cx = classNames.bind(styles);

function PostPage() {
  const { posts, loadPosts } = useContext(FetchDataContext);
  const postRef = useRef();
  const listRef = useRef();
  useEffect(() => {
    loadPosts(false);
  }, []);

  useMeta({
    title: "Danh Sách Bài Đăng - Ngô Gia Quyến",
    description: "Khám phá các bài đăng mới nhất của Ngô Gia Quyến, bao gồm các dự án, bài viết và những chia sẻ thú vị từ cuộc sống và công việc.",
    keywords: "Danh sách bài đăng, Ngô Gia Quyến, bài viết, dự án, chia sẻ, công nghệ, lập trình",
    author: "Ngô Gia Quyến",
    image: "/path/to/your/profile-image.jpg",
    url: routes.PostPage,
  });

  return (
    <div ref={postRef} className={cx('wrapper')}>
      <PostList title='Tất cả bài viết' posts={posts || []} refE={listRef} />
    </div>
  );
}

export default PostPage;
